module.exports = __webpack_public_path__ + "static/find-solution-for-the-covid19-impact-803a05ddf4ca818f4c62f13586972939.png";